
import { defineComponent } from "vue";
import NavbarSideLink from "./NavbarSideLink.vue";

export default defineComponent({
  name: "NavbarSide",
  components: {
    NavbarSideLink
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    return {};
  }
});
